"use strict";
function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while (++index < length) {
        if (comparator(value, array[index])) {
            return true;
        }
    }
    return false;
}
module.exports = arrayIncludesWith;
//# sourceMappingURL=_arrayIncludesWith.js.map